import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { Card } from '@/components/StackCards/types';
import { NumericRange } from '@/types/range';
import { mergeClasses } from '@/utils/style';
import { Button } from '@/components/buttons';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { StackCards } from '@/components/StackCards';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
export function HowItWorks() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["extendedWarranty"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = Array.from({
      length: 4
    }, (_, index) => {
      const cardIndex = index + 1 as NumericRange<1, 4>;
      return {
        index,
        title: <div className={mergeClasses(cardIndex === 4 && "text-center lg:text-left")}>{t(`howItWorks.items.${cardIndex}.title`)}</div>,
        ...(cardIndex < 4 ? {
          description: <Trans t={t} i18nKey={`howItWorks.items.${cardIndex}.text`}><Link to={LINKS().registration} testId="extendedWarrantyRegistration" analyticsParam="extendedWarrantyRegistration" /><Link to={`${LINKS().insurance}#how-it-works`} testId="extendedWarrantyInsurance" analyticsParam="extendedWarrantyInsurance" /></Trans>
        } : {
          footer: <Button analyticsParam="extendedWarrantyRegistration" testId="extendedWarrantyRegistration" variant="primary" size="lg" className="m-auto w-full md:w-auto lg:m-0" to={LINKS().registration}>{t(`howItWorks.items.${cardIndex}.text`)}</Button>
        }),
        images: {
          ...(cardIndex < 3 && {
            variant: "appMockup"
          }),
          desktop: {
            src: `/images/sections/extendedWarranty/cs/cards/${cardIndex}.png`,
            alt: t(`howItWorks.items.${cardIndex}.title`)
          },
          mobile: {
            src: `/images/sections/extendedWarranty/cs/cards/${cardIndex}.png`,
            alt: t(`howItWorks.items.${cardIndex}.title`)
          }
        }
      };
    });
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cards = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("howItWorks.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <SectionHeadline className="mb-12 px-4 md:mb-16" anchorKey="howItWorks.title">{t2}</SectionHeadline>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cards) {
    t4 = <StackCards imagePosition="left" cards={cards} />;
    $[7] = cards;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}